// import ScrollMagic from 'scrollmagic';
// import { TweenMax, TimelineMax, Linear } from 'gsap';
// import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

export default () => {
  if (!document.querySelector('.editorial-promo')) {
    return;
  }

  // ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

  const parallax_controller = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 'onEnter',
      duration: '200%',
    },
  });

  document.querySelectorAll('.editorial-promo__illustration').forEach(parallax_element => {
    const trig = parallax_element.parentElement;

    new ScrollMagic.Scene({
      triggerElement: trig,
    })
      .setTween(parallax_element, { y: '50%', ease: Linear.easeNone })
      .addTo(parallax_controller);
  });
};
